import type {
    HttpMethod,
    HttpStatusCode,
    MutableHttpHeaders,
    ReadonlyHttpHeaders
} from '../../types/web/http';

import { AbstractHttpRequest, AbstractHttpResponse } from '../http/exchange.ts';
import { MapHttpHeaders } from '../http/headers.ts';

export abstract class AbstractClientHttpRequest extends AbstractHttpRequest<MutableHttpHeaders>  {

    protected constructor(method: HttpMethod, uri: URL) {
        super(new MapHttpHeaders());
        this.URL = uri;
        this.method = method;
    }

    readonly URL: URL;
    readonly method: HttpMethod;
}

export abstract class AbstractClientHttpResponse extends AbstractHttpResponse<ReadonlyHttpHeaders> {
    protected constructor(statusCode: HttpStatusCode, headers: ReadonlyHttpHeaders) {
        super(headers);
        this.statusCode = statusCode;
    }
    readonly statusCode: HttpStatusCode;
}
